import { AuthService } from "@/services/AuthService";
import { ProfileService } from "@/services/ProfileService";
import axios from "axios";
import { setupInterceptors } from "@/services/Interceptors";
/**
 * Services
 */
export const authService = AuthService.getInstance();
export const profileService = ProfileService.getInstance();
// Set global Axios defaults
axios.defaults.withCredentials = true;

setupInterceptors();
